// driving_school_classroom_filter_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "locationFilter",
    "typeFilter",
    "programsTable",
    "tableRow"
  ]

  connect() {
    // Initialize filters on page load
    this.filter()
  }

  filter() {
    const selectedLocation = this.hasLocationFilterTarget ? this.locationFilterTarget.value : ""
    const selectedType = this.hasTypeFilterTarget ? this.typeFilterTarget.value : ""

    this.tableRowTargets.forEach(row => {
      const rowLocation = row.dataset.location || ""
      const rowType = row.dataset.type || ""

      const locationMatch = selectedLocation === "" || selectedLocation === rowLocation
      const typeMatch = selectedType === "" || selectedType === rowType

      if (locationMatch && typeMatch) {
        row.style.display = ""
      } else {
        row.style.display = "none"
      }
    })
  }

  programsTableTargetConnected() {
    this.filter()
  }
}

